/* eslint-disable class-methods-use-this */
import React, { PropTypes, Component } from 'react'
import classnames from 'classnames'
import Heading from 'components/Heading'
import Table from 'components/Table'
import Card from 'components/Card'
// import moment from 'moment'
import { format, parse } from 'date-fns'
import constants from 'constants'
import { IconEPICDocument, IconDocumentDone } from '../../../../icons'
import DocumentAwaitingPlan from '../../../../icons/svg/DocumentAwaitingPlan.svg'
import DocumentCard from './DocumentCard'

const styles = Object.assign(
  {},
  require('./Sidebar.scss'),
  { columns: require('./columns.scss') },
  { table: require('components/Table/Table.scss') },
)

const headerStyles = classnames(styles.table.unSortable)

export class SidebarPartnerPlan extends Component {
  static propTypes = {
    handleOpenDialog: PropTypes.func,
    partnerPlanDocuments: PropTypes.obj,
  }
  static defaultProps = {
    handleOpenDialog: null,
    partnerPlanDocuments: [],
  }

  render() {
    const { handleOpenDialog, partnerPlanDocuments } = this.props
    if (partnerPlanDocuments && partnerPlanDocuments.length > 0) {
      return (
        <section className={styles.plandocuments}>
          <Heading noTopPadding>My plan</Heading>
          <Card noPadding>
            <Table>
              { partnerPlanDocuments.filter(pp => pp.documentType === constants.PARTNERPLAN.DOCUMENTTYPE.PLAN).map((doc, i) => (
                (i === 0 && <tr className={styles.base} key={doc.itemId}>
                  <td className={styles.columns.docIcon}>{
                    (doc.planStatus === constants.PARTNERPLAN.STATUS.DRAFT
                    || doc.planStatus === constants.PARTNERPLAN.STATUS.UPLOADED
                    || doc.planStatus === constants.PARTNERPLAN.STATUS.SUBMITTED)
                    ? <IconEPICDocument height="18" width="18" />
                    : <IconDocumentDone height="18" width="18" />}
                  </td>
                  <td className={styles.columns.docLink}>
                    <div><a href={doc.path} rel="noopener noreferrer" target="_blank" title={doc.documentName}>{doc.name}</a></div>
                    <div className={styles.columns.docDate}>Uploaded: {(doc.modifiedDate ? format(parse(doc.modifiedDate, constants.DATE_FORMAT.SPO_FORMAT, new Date()), constants.DATE_FORMAT.PARTNER_PLAN_DOCLIST) : '')}</div>
                  </td>
                </tr>)
              )) }
            </Table>
          </Card>
          <DocumentCard
            documentTitle={constants.PARTNERPLAN.STEPS.INTERIM_ASSESSMENT}
            handleOpenDialog={handleOpenDialog}
            partnerPlanDocuments={partnerPlanDocuments.filter(pp => pp.documentType === constants.PARTNERPLAN.DOCUMENTTYPE.INTERIM)}
          />
          <DocumentCard
            documentTitle={constants.PARTNERPLAN.STEPS.FINAL_ASSESSMENT}
            handleOpenDialog={handleOpenDialog}
            partnerPlanDocuments={partnerPlanDocuments.filter(pp => pp.documentType === constants.PARTNERPLAN.DOCUMENTTYPE.FINAL)}
          />
        </section>
      )
    }
    return (
      <section className={styles.plandocuments}>
        <Heading noTopPadding>My plan</Heading>
        <Card cardMyPlan>
          <img alt="Document Awaiting Plan" src={DocumentAwaitingPlan} />
        </Card>
      </section>
    )
  }
}

export default SidebarPartnerPlan



// WEBPACK FOOTER //
// ./src/views/PartnerPlans/components/Sidebar/Sidebar.js